import { Injectable } from '@angular/core';
import { Interface } from '@freelancer/types';
import * as Rx from 'rxjs';
import { HeartbeatTrackingCancellation } from '../tracking.model';
import { Tracking } from '../tracking.service';

@Injectable()
export class TrackingTesting implements Interface<Tracking> {
  private sessionId: string;

  constructor() {
    this.sessionId = 'sessionId';
  }

  // DO NOT CALL THAT FROM THE app/ CODE. IT'LL BE RESTRICTED SOON.
  track(eventType: unknown, eventData: unknown): Promise<void> {
    return Promise.resolve();
  }

  getSessionId(): Rx.Observable<string> {
    // sessionId could eventually be turned into a true observable
    return Rx.of(this.sessionId);
  }

  trackPageView(is404?: boolean): Promise<void> {
    // Do nothing
    return Promise.resolve();
  }

  trackCustomEvent(
    name: string,
    section?: string,
    extraData?: { [key: string]: string | number },
  ): Promise<void> {
    // Do nothing
    return Promise.resolve();
  }

  trackHeartbeat(
    name: string,
    referenceType?: string,
    referenceId?: string,
  ): Promise<HeartbeatTrackingCancellation> {
    return Promise.resolve(() => {
      // do nothing
    });
  }

  trackSearch({
    filters,
    itemsCount,
    itemsDisplayed,
    itemsPage,
    keyword = '',
    section,
    sort,
    source,
  }: {
    readonly filters: {
      [k: string]: any;
    };
    readonly itemsCount: number;
    readonly itemsDisplayed: number;
    readonly itemsPage: number;
    readonly keyword?: string;
    readonly section: string;
    readonly sort?: string;
    readonly source: string;
  }): Promise<void> {
    return Promise.resolve();
  }

  sendEventBacklog(): Promise<void> {
    // Do nothing
    return Promise.resolve();
  }
}
